module.exports = __webpack_public_path__ + "static/media/wheel_person_mobile.e969d9e8.png";